import { useCallback } from "react";
import { AxiosInstance } from "axios";
import { getOverviewEndpointBaseUrl } from "@shared/config/featureFlags";
import { CachedFetch, useCachedFetch } from "@shared/hooks/useCachedFetch";
import { getCpeLatencyAPI } from "../../requests/request";
import { OverviewCpeLatency } from "../Types";

/**
 * RTT of the tenant's Backhaul legs (CTX-1461), for the dotted CPE lines of the
 * Overview map. The answer belongs to the tenant, so the cache key carries it.
 * No tenant-type gate: the endpoint scopes by tenant and serves every type.
 * Callers treat a failure as "no RTT": the map never waits for it.
 */
export function useCpeBackhaulLatency(api: AxiosInstance, tenantId: number): CachedFetch<OverviewCpeLatency> {
  const baseUrl = getOverviewEndpointBaseUrl();
  const load = useCallback(async () => {
    const response = await getCpeLatencyAPI(api, baseUrl ?? "", tenantId);
    const data = response.data?.data as OverviewCpeLatency | null | undefined;
    if (!data) throw new Error(response.data?.message || "No Backhaul latency");
    return data;
  }, [api, baseUrl, tenantId]);
  const key = baseUrl && tenantId ? `kontroledge/overview/cpe-latency?tenantId=${tenantId}` : null;
  return useCachedFetch(key, load);
}
